import { createSlice } from '@reduxjs/toolkit';

import { ListUsersResult, StatusType, UserRecord } from '../../gql/ListUsers';
import { SupplierEntry } from '../../interfaces/RFXRequestForm';
import { RootState } from '../../store';

/**
 * This reducer is deprecated after fetching suppliers and contacts have been
 * migrated away from ListUsers to SearchVendorEntity and
 * GetUsersForBusinessEntityId
 * 
 * TODO - Once vendor service integration is completed this file can be removed.
 */
export interface SupplierEntriesState {
  continuationToken: string | null; // Not used currently.
  didQueryFail: false;
  fetchedResult: ListUsersResult | undefined;
  maxResults: number; // Max should 100, limit from User Management Service.
  statusType: StatusType;
  supplierData: SupplierEntry[];
  supplierContactsData: Map<string, UserRecord[]>;
  timeOfUpdateMillis: number; // Not used currently.
  timeToResetSeconds: number; // Not used currently.
}

const initialState: SupplierEntriesState = {
  continuationToken: null, // Not used currently.
  didQueryFail: false,
  fetchedResult: undefined,
  maxResults: 100, // Max should 100, limit from User Management Service.
  statusType: 'pending',
  supplierData: [],
  supplierContactsData: new Map<string, UserRecord[]>(),
  timeOfUpdateMillis: 0, // Not used currently.
  timeToResetSeconds: 3600 // Not used currently.
};

const supplierEntriesSlice = createSlice({
  name: 'manageSupplierEntries',
  initialState,
  reducers: {
    setContinuationToken(state, action) {
      state.continuationToken = action.payload;
    },
    setDidQueryFail(state, action) {
      state.didQueryFail = action.payload;
    },
    setFetchedResult(state, action) {
      state.fetchedResult = action.payload;
    },
    setMaxResults(state, action) {
      state.maxResults = action.payload;
    },
    setStatusType(state, action) {
      state.statusType = action.payload;
    },
    setSupplierData(state, action) {
      state.supplierData = action.payload;
    },
    setSupplierContactsData(state, action) {
      state.supplierContactsData = action.payload;
    },
    setTimeOfUpdateMillis(state, action) {
      state.timeOfUpdateMillis = action.payload;
    },
    setTimeToResetSeconds(state, action) {
      state.timeToResetSeconds = action.payload;
    }
  }
});

export const {
  setContinuationToken,
  setDidQueryFail,
  setFetchedResult,
  setMaxResults,
  setStatusType,
  setSupplierData,
  setSupplierContactsData,
  setTimeOfUpdateMillis,
  setTimeToResetSeconds
} = supplierEntriesSlice.actions;

export const selectContinuationToken = (state: RootState) => state.manageSupplierEntries.continuationToken;

export const selectDidQueryFail = (state: RootState) => state.manageSupplierEntries.didQueryFail;

export const selectFetchedResult = (state: RootState) => state.manageSupplierEntries.fetchedResult;

export const selectMaxResults = (state: RootState) => state.manageSupplierEntries.maxResults;

export const selectStatusType = (state: RootState) => state.manageSupplierEntries.statusType;

export const selectSupplierData = (state: RootState) => state.manageSupplierEntries.supplierData;

export const selectSupplierContactsData = (state: RootState) => state.manageSupplierEntries.supplierContactsData;

export const selectTimeOfUpdateMillis = (state: RootState) => state.manageSupplierEntries.timeOfUpdateMillis;

export const selectTimeToResetSeconds = (state: RootState) => state.manageSupplierEntries.timeToResetSeconds;

export default supplierEntriesSlice.reducer;
